import { Configuration } from "../api/order/generated/src";


export function getOrderApiConfig(language?: string ) {
    
    // todo: token
    const token = "";

    let headers = null;

    if (language) {
        headers = {
            'Accept-Language': language,
        }
    }
    
    if (!process.env.REACT_APP_API_C3PO) {
        if (headers) {
            return new Configuration({ accessToken: token, headers })
        }
        return new Configuration({ accessToken: token })    
    }

    let url = process.env.REACT_APP_API_C3PO
    if (headers) {
        return new Configuration({ basePath: url, accessToken: token, headers })
    }
    return new Configuration({ basePath: url, accessToken: token })
}
